import { Stripe } from "stripe";
import { ApiErrorResponse, IRetryData } from "./types";
import {
  handlePaymentThatRequiresCustomerAction,
  onSubscriptionComplete,
} from "./utils";

export async function retrySubscription(
  data: IRetryData & { priceLookUpKey: string }
) {
  return (
    fetch(process.env.REACT_APP_API_URL + "/retrySubscription", {
      mode: "cors",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Cache-Control": "no-cache",
      },
      body: JSON.stringify(data),
    })
      .then(async (response) => {
        return (await response.json()) as
          | ApiErrorResponse
          | Stripe.Response<Stripe.Invoice>;
      })
      .then((result) => {
        if ((result as ApiErrorResponse).error) {
          // The card had an error when trying to attach it to a customer.
          throw (result as ApiErrorResponse).error;
        }
        return result;
      })
      .then((result) => ({
        paymentMethodId: data.paymentMethodId,
        priceLookUpKey: data.priceLookUpKey,
        invoice: result as Stripe.Response<Stripe.Invoice>,
        isRetry: true,
      }))
      // Some payment methods require a customer to be on session
      // to complete the payment process. Check the status of the
      // payment intent to handle these actions.
      .then(handlePaymentThatRequiresCustomerAction)
      // No more actions required. Provision your service for the user.
      .then(onSubscriptionComplete)
  );
}
